import React from "react";
import { 
    AlertCircle,
    CircleCheck,
    Clock,
    Handshake,
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import NewItemButton from "components/button/NewItemButton";
import SupportTicket from "./components/SupportTicket";
import SupportTabs from "./components/SupportTabs";

const PartnerService = () => {
    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6 max-w-[1800px]">
                <SummaryHeader
                    title={"Partner Service"}
                    icon={Handshake}
                    description={"Billing, contracts, and partnership support"}
                    color={"bg-purple"}
                    rightNav={
                        <NewItemButton
                            textColor="text-purple-600" 
                            hoverBgColor="hover:bg-purple-50"
                        >
                            <SupportTicket />
                        </NewItemButton>
                    }
                >
                   <div className="summary-item-container">
                        <SummaryItem
                            title="Open Tickets"
                            icon={<AlertCircle />}
                            display="2"
                        />
                        <SummaryItem
                            title="In Progress"
                            icon={<Clock />}
                            display="2" 
                        />
                        <SummaryItem
                            title="Resolved"
                            icon={<CircleCheck />}
                            display="1" 
                        />
                   </div>
                </SummaryHeader>
                <SupportTabs />
            </div>
        </div>
    )
};
export default PartnerService;